export const CLEAR_IAB_CATEGORIES = 'CLEAR_IAB_CATEGORIES'
export const CLEAR_BLOCKED_DOMAINS = 'CLEAR_BLOCKED_DOMAINS'
export const SET_BLOCKED_IAB_CATEGORIES = 'SET_BLOCKED_IAB_CATEGORIES'
export const SET_BLOCKED_DOMAINS = 'SET_BLOCKED_DOMAINS'
export const SET_IAB_CATEGORIES = 'SET_IAB_CATEGORIES'
